// extracted by mini-css-extract-plugin
module.exports = {"greyTag":"PostsListingDetailed-module--greyTag--Or3Be","twoColumns":"PostsListingDetailed-module--twoColumns--1dE0v","postBlock":"PostsListingDetailed-module--postBlock--2QL52"};